import { observer } from 'mobx-react';
import { renderPriceInfo, renderWeightPriceInfo } from '@/utils/misc';

const MobilePriceInfo = observer(({ priceDetails }) => {
  const renderContent = () => {
    if (!priceDetails) return null;

    const isWeightBased = priceDetails.isWeightBased;

    if (isWeightBased) {
      return renderWeightPriceInfo(priceDetails);
    } else {
      return renderPriceInfo(priceDetails);
    }
  };

  return <>{renderContent()}</>;
});

export default MobilePriceInfo;